<script setup lang="ts">
const { t } = useI18n()
const { gaMeasurementId } = useRuntimeConfig().public
const consent = useAnalyticsConsent()
</script>

<template>
  <UFooter :ui="{ top: 'border-b border-default' }">
    <template #left>
      <p class="text-muted text-sm">
        {{ t('footer.copyright', { year: new Date().getFullYear() }) }}
      </p>
    </template>

    <template #right>
      <UButton
        v-if="gaMeasurementId"
        :label="t('consent.settings')"
        icon="i-lucide-cookie"
        color="neutral"
        variant="ghost"
        size="sm"
        data-testid="footer-cookie-settings"
        @click="consent = null"
      />
      <UButton
        to="mailto:support@robotrealm.ag-hotel.com"
        icon="i-lucide-mail"
        :aria-label="t('footer.contactAriaLabel', 'Contact us')"
        color="neutral"
        variant="ghost"
      />
    </template>
  </UFooter>
</template>
